module.exports = __webpack_public_path__ + "img/home_bg2_d@2x.7d449eb0.png";